import Vue from 'vue';
import VueRouter from 'vue-router';
import SwapIndex from '../views/swap/Index.vue';

import Swap from '../views/swap/Swap.vue';
import Home from '../views/Home.vue';
import LiquidityIndex from '../views/liquidity/Index.vue';
import Liquidity from '../views/liquidity/Liquidity.vue';
import importMining from '../views/liquidity/importMining.vue';
import Remove from '../views/liquidity/Remove.vue';
import CrossChainBridge from '../views/CrossChainBridge/Index.vue';

import HomeNext from '../views/HomeNext.vue';

Vue.use(VueRouter);
const routes = [

  {
    path: '/',
    redirect: 'SwapIndex/Swap',
    component: Home,
    children: [
      {
        path: 'SwapIndex',
        name: 'SwapIndex',
        component: SwapIndex,
        children: [
          {
            path: 'Swap',
            name: 'Swap',
            component: Swap,
          },
          {
            path: 'LiquidityIndex',
            name: 'LiquidityIndex',
            component: LiquidityIndex,
          },
          {
            path: 'Liquidity',
            name: 'Liquidity',
            component: Liquidity,
          },
          {
            path: 'importMining',
            name: 'importMining',
            component: importMining,
          },
          {
            path: 'Remove',
            name: 'Remove',
            component: Remove,
          },
           {
            path: 'CrossChainBridge',
            name: 'CrossChainBridge',
            component: CrossChainBridge,
          },
        ],
      },
    
    
    
     
   
    ],
  },
  {
    path: '/HomeNext',
    name: 'HomeNext',
    component: HomeNext,
    children: [
    
    ]
  },
];

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  // base: './',
  routes,
});

export default router;
